// extracted by mini-css-extract-plugin
export var childrenContainer = "_ci-0";
export var virtualScrollArea = "_ci-1";